import React from "react";
import { AnalystImage } from "./AnalystImage";
import { i18n } from "app/i18n/i18n";
import { isPublicPath } from "lib/routing";
import { push } from "pages/search/api/filterUrlMaker";
import { Button } from "react-bootstrap";

export const AnalystCard = ({ fullName, title, regions, imageURL, lang = i18n.getLanguage() }) => (
  <article id={fullName.en} className="w-100 text-dark rounded-0 border-0 d-flex pt-md-0 justify-content-between">
    <AnalystImage imageURL={imageURL} fullName={fullName[lang]} isThumbnail />

    <aside className="w-100 ml-2">
      <AnalystName fullName={fullName} lang={lang} />
      <AnalystDetails title={title} regions={regions} lang={lang} />
    </aside>
  </article>
);

const AnalystName = ({ fullName, lang }) =>
  isPublicPath() ? (
    <b>{fullName[lang]}</b>
  ) : (
    <Button
      variant="link text-primary text-left m-0 p-0"
      onClick={() => {
        push(null, "/Analyst_Directory#" + fullName.en);
        push(null, "/Analyst?Analyst=" + fullName.en);
      }}
    >
      <b>{fullName[lang]}</b>
    </Button>
  );

const AnalystDetails = ({ title, regions, lang }) => (
  <section>
    <small className="text-gray d-block">
      {title}
      <br />
      {regions?.[0]?.name?.[lang]}
      <br />
      <br />
    </small>
  </section>
);
